import getCurrentPath from '@nicolaudie-group/ng-ui-kit/helpers/getCurrentPath'
import useUserStore from '@/stores/user.store'

function useLogout() {
  const userStore = useUserStore()

  function logout({ switchAccount }) {
    // If we're just switching account, keep the session
    return userStore.goToLogout({ goto: getCurrentPath(), keepSession: switchAccount })
  }

  return logout
}

export default useLogout
